import type { AfcSubmission, BioRenderableCandidate } from '@axiom/validation';
import { BarredLocationsConst } from '@axiom/const';

import { CandidateProposedRateUtil } from './candidate-proposed-rate-util';

export const CandidateHighlightsUtil = {
  calculateNumberOfHighlights(
    candidate: BioRenderableCandidate,
    submission?: AfcSubmission | null
  ) {
    const highlightValues = [
      submission &&
        CandidateProposedRateUtil.formatCandidateRate(
          candidate.id,
          submission
        ) !== '--' &&
        CandidateProposedRateUtil.formatCandidateRate(candidate.id, submission),
      (candidate.lawDegreeSchools?.length ?? 0) > 0,
      candidate.yearsOfExperience && candidate.yearsOfExperience >= 0,
      (candidate.barredLocations?.filter(
        admission => admission.name !== BarredLocationsConst.Names.NotAdmitted
      ).length ?? 0) > 0,
      (candidate.industries?.length ?? 0) > 0,
      (candidate.lawFirms?.length ?? 0) > 0,
      candidate.addressCity ||
        candidate.addressState ||
        candidate.addressCountry,
    ];
    return highlightValues.filter(Boolean).length;
  },
  calculateNumberOfSummaryHighlights(candidate: BioRenderableCandidate) {
    return [
      candidate.yearsOfExperience && candidate.yearsOfExperience >= 0,
      (candidate.lawDegreeSchools?.length ?? 0) > 0,
      (candidate.barredLocations?.filter(
        admission => admission.name !== BarredLocationsConst.Names.NotAdmitted
      ).length ?? 0) > 0,
    ].filter(Boolean).length;
  },
};
